// import React from "react";
// import AdminAppBody from "../../../../components/admin/AdminAppBody"; // Adjust path if needed

// const pdfResources = [
//   {
//     title: "React (Intermediate) (1).pdf",
//     url: "https://example.com/React-Intermediate.pdf",
//   },
//   {
//     title: "Digital Marketing Certification Program Handbook (1).pdf",
//     url: "https://example.com/Digital-Marketing.pdf",
//   },
//   {
//     title: "React Certification Program Handbook (1).pdf",
//     url: "https://example.com/React-Certification.pdf",
//   },
// ];

// const Resource = () => {
//   return (
//     <AdminAppBody
//     content={
//       <div className="container py-4">
//         <h4 className="fw-bold mb-4">React</h4>
//         <div className="row">
//           {pdfResources.map((pdf, index) => (
//             <div className="col-md-4 mb-4" key={index}>
//               <div className="card shadow-sm h-100">
//                 <div className="card-body d-flex flex-column justify-content-between">
//                   <div className="d-flex align-items-center mb-3">
//                     <span
//                       style={{
//                         color: "red",
//                         fontSize: "20px",
//                         marginRight: "8px",
//                       }}
//                     >
//                       📄
//                     </span>
//                     <span className="fw-medium">{pdf.title}</span>
//                   </div>
//                   <a
//                     href={pdf.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn btn-primary w-100"
//                   >
//                     View
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
// }/>
//   );
// };

// export default Resource;

import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";

const Resource = () => {
  const [resources, setResources] = useState([]);
  const [response, loading, error, callAPI] = useApiCallHooks();

  useEffect(() => {
    callAPI("get", "admin/program-resource"); // Adjust API path if needed
  }, []);

  useEffect(() => {
    if (response?.data && Array.isArray(response.data)) {
      setResources(response.data);
    }
  }, [response]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container py-4">
          <h4 className="fw-bold mb-4">Program Resources</h4>
          <div className="row">
            {resources.length ? (
              resources.map((res, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="card shadow-sm h-100">
                    <div className="card-body d-flex flex-column justify-content-between">
                      <div className="d-flex align-items-center mb-3">
                        <span
                          style={{
                            color: "red",
                            fontSize: "20px",
                            marginRight: "8px",
                          }}
                        >
                          📄
                        </span>
                        <span className="fw-medium">
                          {res.file?.split("/").pop() || "PDF File"}
                        </span>
                      </div>
                      <a
                        href={res.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary w-100"
                      >
                        View
                      </a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <p className="text-center">No resources available.</p>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
};

export default Resource;

